import { MstrWrapperProps } from '@/core/interfaces/usestate-interfaces';
import { mstrService } from '@/projects/platform/services/mstr-service';
import { useEffect, useState } from 'react';

declare global {
    interface Window {
        microstrategy: any;
    }
}



const MstrWrapper: React.FC<MstrWrapperProps> = ({ getReport }) => {
    const [authToken, setAuthToken] = useState<any>();
    useEffect(() => {
        getReport().then((resp) => {


            const script = document.createElement('script');
            script.src = resp.data.host + '/MicroStrategyLibrary/javascript/embeddinglib.js';
            script.async = true;
            script.onload = () => scriptLoaded();
            document.body.appendChild(script);

            async function scriptLoaded() {

                const placeholderDiv = document.getElementById("dossierContainer");

                let mstrToken = localStorage.getItem("mstr_token");
                await mstrService.logout(resp.data.host, mstrToken);

                async function getLoginToken() {


                    let isTokenValid = false;

                    if (mstrToken) {
                        isTokenValid = await mstrService.checkSession(resp.data.host, mstrToken);
                    }
                    if (!isTokenValid) {

                        mstrToken = await mstrService.mstrLogin(resp.data.host, resp.data.username, resp.data.password)

                    }
                    return mstrToken;

                }

                window.microstrategy.dossier.create({
                    placeholder: placeholderDiv,
                    url: resp.data.embedUrl,
                    enableResponsive: true,
                    customAuthenticationType: window.microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN,
                    enableCustomAuthentication: true,
                    errorHandler: async (errorObject: any) => {
                        if (errorObject.statusCode === 403)
                            setAuthToken(await mstrService.mstrLogin(resp.data.host, resp.data.username, resp.data.password))
                    },
                    getLoginToken
                });
            }
        })


    }, [authToken])


    return (
        <div id="dossierContainer" className="embedded-mstr">
        </div>
    );
};

export default MstrWrapper;